'use client';

import React, { useState } from 'react';
import ActivityCards from './ActivityCards';
import FoodCards from './FoodCards';
import StallHolders from './StallHolders';

const tabs = [
  { id: 'tab-activities', label: '🎪 Activities', value: 'activities' },
  { id: 'tab-food', label: '🍔 Food', value: 'food' },
  { id: 'tab-stalls', label: '🛍️ Stalls', value: 'stalls' },
];

export default function ActivitiesTabs() {
  const [activeTab, setActiveTab] = useState('activities');

  return (
    <div>
      {/* Tab bar */}
      <div className="px-4 pt-4 pb-2 bg-background sticky top-[105px] z-30 border-b border-border">
        <div className="flex gap-2">
          {tabs?.map((tab) => (
            <button
              key={tab?.id}
              onClick={() => setActiveTab(tab?.value)}
              className={`flex-1 py-2.5 px-3 rounded-xl text-xs font-bold transition-all duration-200 touch-target ${
                activeTab === tab?.value
                  ? 'gradient-primary text-secondary' :'bg-muted text-muted-foreground hover:bg-muted/80'
              }`}
            >
              {tab?.label}
            </button>
          ))}
        </div>
      </div>
      <div className="px-4 pt-4 pb-6">
        {activeTab === 'activities' && <ActivityCards />}
        {activeTab === 'food' && <FoodCards />}
        {activeTab === 'stalls' && <StallHolders />}
      </div>
    </div>
  );
}